import { GroupCondition } from '@/api/enums';
import { equal, group } from '@/api/helpers';
import { CourseStatusAttemptEnum, MaterialType } from '@/client/courses';
import { useLearnerCourses } from '@/hooks/query';
import { LoadingPage } from '@/pages/LoadingPage';
import React, { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';

type LearnerContextProps = {
  contentToDo: number;
};

const LearnerContext = createContext<LearnerContextProps>({
  contentToDo: 0,
});

type LearnerProviderProps = {
  children: React.ReactNode;
  isLoading?: boolean;
};

export const LearnerProvider: React.FC<LearnerProviderProps> = ({
  children,
  isLoading,
}) => {
  const { t } = useTranslation();
  const { isLoading: areContentToDoLoading, learnerCourses: contentToDo } =
    useLearnerCourses({
      take: 0,
      skip: 0,
      type: CourseStatusAttemptEnum.IN_PROGRESS,
      filters: [
        group(GroupCondition.OR, [
          equal('type', MaterialType.CUSTOM_MATERIAL),
          equal('type', MaterialType.COURSE),
        ]),
      ],
    });

  return (
    <>
      {isLoading || areContentToDoLoading ? (
        <LoadingPage message={t('generic.loading')} />
      ) : (
        <LearnerContext.Provider
          value={{
            contentToDo: contentToDo?.count ?? 0,
          }}
        >
          {children}
        </LearnerContext.Provider>
      )}
    </>
  );
};

// Custom hook to use the SCORM context
export const useLearner = () => useContext(LearnerContext);
